export const formValidation = (e: React.ChangeEvent<HTMLInputElement>) => {
    var rgx = /^[0-9]*\.?[0-9]*$/;
    return e.target.value.match(rgx)
}